import { CanvasResizeInterface }  from './canvas.resize.interface';
import { CanvasObject }           from './canvas.object';
import { Visual }                 from './visuals/visual';
import { EventHandlerInterface }  from './events/event.handler.interface';
import { HighLighterInterface }   from './high.lighter.interface';

/**
 *
 * @class VirtualCanvas
 *
 * This is the base adaptor for whatever canvas framework/kit we are working
 * with.  Subclasses should implement their own version of all methods.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      January 2024
 *
 */
export class VirtualCanvas {

  /** the highlight manager */
  public highlighter: HighLighterInterface|null     = null;

  /** the current width of the canvas */
  public width: number                              = 0;

  /** the current height of the canvas */
  public height: number                             = 0;

  /** the objects we must notification when the canvas changes size */
  private resizableObjects: CanvasResizeInterface[] = [];

  /** add to the list of objects we notify for canvas resize events */
  registerResizable(obj: CanvasObject): VirtualCanvas {

    this.resizableObjects.push(obj);

    return this;
  }

  /** resize the canvas to exactly this width and height */
  public resize(width: number, height: number): VirtualCanvas {

    /* subclasses must implement */

    return this;
  }

  /** on window size changes, notify children or layouts to update themselves. */
  public onResize(): VirtualCanvas {

    let vc: VirtualCanvas = this;

    this.resizableObjects.forEach((x: CanvasResizeInterface): void => {

      x.resize(vc.width, vc.height);

    });

    return this;
  }

  /** helper to clear any rendered visuals */
  public clear(): VirtualCanvas {

    /* subclasses must implement */

    return this;
  }

  /** add a visual to the canvas and return an ID/handle for that visual. */
  public addShape(obj: Visual, eventHandler: EventHandlerInterface|null|undefined = null): any {

    /* subclasses must implement */

    return this;
  }

  /** update the canvas object with the given visual parameters, and return the existing ID/handle */
  public updateShape(obj: Visual): any {

    /* subclasses must implement */

    return this;
  }

}
